import { timePeriodsFactory } from './categories';
import { hasValue } from '../../utils/filter/selection';

const RACE_TYPE = 'raceType';
const getRaceType = val => val.match(/jumps|flat/)[0];
const getCountry = val => val.match(/GB|IRE/)[0];

const timePeriodReducer = (categories, { type, value }) => {
    const { timePeriod } = categories;

    if (!hasValue(categories[type], value)) {
        return timePeriod;
    }

    if (type === RACE_TYPE) {
        const newRaceType = getRaceType(value);
        if (timePeriod.createdBy.raceType !== newRaceType) {
            return timePeriodsFactory(getCountry(value), newRaceType);
        }
    }
    return timePeriod;
};

const raceTypeReducer = categories => categories.raceType;

const categoriesReducer = (categories, action) => ({
    raceType: raceTypeReducer(categories),
    timePeriod: timePeriodReducer(categories, action),
});


export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/human/horses/categoriesReducer.js